/**
 * @module use-cases/slice/showcases
 * @desc Showcases Slice (Reducers and ExtraReducers)
 */

import { createSlice } from 'core/use-cases/utilities';
import { Utilities } from 'core/domains';

import * as actions from './actions';
import { initialState } from './initial-state';

const showcasesSlice = createSlice({
  name: 'showcases',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(actions.showcasesCleanUp, (state) => {
      state.data = [];
    });

    builder.addCase(actions.availableShowcasesFetch.request, (state, { payload }) => {
      state.data = [];
      state.availableShowcases = [];
      state.isRunning = true;
      state.status = Utilities.STATUS.RUNNING;
      state.updatedAt = 0;
    });

    builder.addCase(actions.availableShowcasesFetch.success, (state, { payload, meta }) => {
      state.isRunning = false;
      state.status = Utilities.STATUS.SUCCESS;
      state.updatedAt = meta.updatedAt;
      const newShowcases = payload.data.map((showcase) => {
        if (showcase.tag === 'recommendation') {
          return {
            ...showcase,
            name: 'Selecionados para você',
          };
        }
        return showcase;
      });

      state.availableShowcases = [
        ...newShowcases,
        {
          name: 'Promoções',
          description: '',
          tag: 'discount',
          order: -10,
          multiBrand: payload.data[0].multiBrand,
          isFetched: false,
        },
      ];
    });

    builder.addCase(actions.availableShowcasesFetch.failure, (state, { meta }) => {
      state.isRunning = false;
      state.status = Utilities.STATUS.ERROR;
      state.updatedAt = meta?.updatedAt || 0;
      state.availableShowcases = [];
    });

    builder.addCase(actions.showcasesFetch.request, (state) => {
      state.isRunning = true;
      state.status = Utilities.STATUS.RUNNING;
      state.updatedAt = 0;
    });

    builder.addCase(actions.showcasesFetch.success, (state, { meta, payload }) => {
      state.data = [
        ...state.data,
        {
          ...payload,
          tagName: meta.payload.tag,
          description: meta.payload.description,
          name: meta.payload.name,
        },
      ];
      state.isRunning = false;
      state.status = Utilities.STATUS.SUCCESS;
      state.updatedAt = meta.updatedAt;
      state.availableShowcases = state.availableShowcases.map((availableShowcase) => {
        if (availableShowcase.tag === meta?.payload?.tag) {
          availableShowcase.isFetched = true;
        }
        return availableShowcase;
      });
    });

    builder.addCase(actions.showcasesFetch.failure, (state, { meta }) => {
      state.isRunning = false;
      state.status = Utilities.STATUS.ERROR;
      state.updatedAt = meta?.updatedAt || 0;
      state.availableShowcases = state.availableShowcases.map((availableShowcase) => {
        if (availableShowcase.tag === meta?.payload?.tag) {
          availableShowcase.isFetched = true;
        }
        return availableShowcase;
      });
    });
  },
});

export const { reducer } = showcasesSlice;
export { actions };
